import * as i0 from '@angular/core';
import { InjectionToken, inject, Injectable } from '@angular/core';
import { EC_GATEWAY_WEB_SERVICE, NOTIFICATION_WEB_SERVICE, ADDRESS_WEB_SERVICE } from '@effy-tech/angular-common/web-service';
import { API_KEY } from '@effy-tech/angular-common/environment';

// Whitelisted APIs to add API Key
const APIS_WITH_API_KEY = new InjectionToken('APIs with API key', {
    factory: () => {
        const ecGatewayWebService = inject(EC_GATEWAY_WEB_SERVICE);
        const notificationWebService = inject(NOTIFICATION_WEB_SERVICE);
        const addressWebService = inject(ADDRESS_WEB_SERVICE);
        return [ecGatewayWebService.base, notificationWebService.base, addressWebService.base];
    },
});
const API_KEY_PARAM = 'key';

class ApiKeyInterceptor {
    constructor() {
        this.KEY = inject(API_KEY);
        this.apisWithApiKey = inject(APIS_WITH_API_KEY);
    }
    addKeyParameter(request) {
        return request.clone({
            setParams: {
                [API_KEY_PARAM]: this.KEY,
            },
        });
    }
    intercept(request, next) {
        // Determine if the current request is allowed to add APIKey
        const withApiKey = this.apisWithApiKey.some(apiUrl => request.url.includes(apiUrl));
        // Add key on the current request if needed
        if (withApiKey) {
            request = this.addKeyParameter(request);
        }
        return next.handle(request);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "20.2.4", ngImport: i0, type: ApiKeyInterceptor, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "20.2.4", ngImport: i0, type: ApiKeyInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "20.2.4", ngImport: i0, type: ApiKeyInterceptor, decorators: [{
            type: Injectable
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { APIS_WITH_API_KEY, API_KEY_PARAM, ApiKeyInterceptor };
